import { Card, Checkbox, Space, Tag } from 'antd';
import ImportTitle from './ImportTitle';


const ImportIndustriesStep = ({ accountData, selectedFields, onFieldSelection }) => {
    return (
        <div className="py-6">
            <ImportTitle
                title="Industries"
                description="Select the industries you'd like to import to your profile"
            />

            <Card title={
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <i className="fas fa-building" />
                        <span>Industries ({accountData?.industries_worked?.length || 0})</span>
                    </div>
                    <Space>
                        <Checkbox
                            checked={accountData?.industries_worked?.every((_, idx) => selectedFields?.industries_worked?.[idx])}
                            onChange={(e) => {
                                const newValue = {};
                                accountData?.industries_worked?.forEach((_, idx) => {
                                    newValue[idx] = e.target.checked;
                                });
                                onFieldSelection('industries_worked', newValue);
                            }}
                        >
                            <span className="text-xs text-gray-500">Select All</span>
                        </Checkbox>
                    </Space>
                </div>
            }>
                <Space direction="horizontal" size={8} className="flex-row flex-wrap gap-y-4">
                    {accountData?.industries_worked?.map((industry, index) => (
                        <Tag
                            color={selectedFields?.industries_worked?.[index] ? "purple" : "default"}
                            key={index}
                            className="clickable flex items-center flex-row h7 px-2 pt-1"
                            onClick={() => onFieldSelection('industries_worked', {
                                ...(selectedFields?.industries_worked || {}),
                                [index]: !selectedFields?.industries_worked?.[index]
                            })}
                        >
                            <Space className="flex items-center flex-row h5">
                                <Checkbox
                                    className="mr-2 pointer-events-none"
                                    checked={selectedFields?.industries_worked?.[index]}
                                />
                            </Space>
                            <div className="flex flex-col items-center justify-center pl-1">
                                <span className="text-sm flexitems-centerflex-row">{industry.name}</span>
                                <span className="-mt-0.5">
                                    {laravel.talent_scoring_options[industry.self_score]}
                                </span>
                            </div>
                        </Tag>
                    ))}
                </Space>
            </Card>
        </div>
    );
};

export default ImportIndustriesStep;
